import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHouseSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12 3.813.537.342 7.002 4.456.463.294v11.097H3.998V8.905l.463-.294 7.002-4.456.537-.342Zm-6.002 6.19v8h12.004v-8L12 6.184l-6.002 3.82ZM9.25 12.75h5.5v2h-5.5v-2Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconHouseSharpLine);
export default Memo;
